import Icon from 'vue-awesome/components/Icon'

Icon.register({
  airplanemode_inactive_rounded: {
    paths: [
      {
        d: 'M19.64 15.58c.67.21 1.36-.29 1.36-1 0-.36-.19-.69-.49-.89L13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.11l8.65 8.65.99.32zM18.73 21l1.41-1.41L4.41 3.86 3 5.27l4.99 4.99-5.5 3.44c-.3.18-.49.52-.49.88 0 .7.68 1.21 1.36 1L10 13.5V19l-1.8 1.35a.48.48 0 00-.2.4v.59c0 .33.32.57.64.48L11.5 21l2.86.82c.32.09.64-.15.64-.48v-.59a.48.48 0 00-.2-.4L13 19v-3.73L18.73 21z'
      }
    ],
    width: '24',
    height: '24'
  }
})
